var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-bottom-sticky"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.openInstructions.apply(null, arguments)}}},[_c('i',{staticClass:"icon-sc-chevron-down flip-v"}),_c('span',[_vm._v(_vm._s(_vm.$t('digitalServices.sidebar.items.instructions')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }